import React from "react";
import { FaCalendarAlt } from "react-icons/fa";

const EventsHostedCard = ({ events }) => {
  const getStatusClass = (status) => {
    if (status === "Approved" || status === "Active") {
      return "viewing-organiser-events-table__status-badge viewing-organiser-events-table__status-badge--approved";
    }
    if (status === "Pending") {
      return "viewing-organiser-events-table__status-badge viewing-organiser-events-table__status-badge--pending";
    }
    return "viewing-organiser-events-table__status-badge viewing-organiser-events-table__status-badge--other";
  };

  return (
    <div className="viewing-organiser-card viewing-organiser-full-width-card">
      <div className="viewing-organiser-card__header viewing-organiser-card__header--secondary">
        <FaCalendarAlt className="viewing-organiser-card__icon" />
        <h2 className="viewing-organiser-card__title">Events Hosted</h2>
      </div>
      <div className="viewing-organiser-card__body viewing-organiser-events-wrapper">
        <table className="viewing-organiser-events-table">
          <thead>
            <tr>
              <th>Event Name</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {events && events.length > 0 ? (
              events.map((event) => (
                <tr key={event.id}>
                  <td className="viewing-organiser-events-table__name">{event.name}</td>
                  <td className="viewing-organiser-events-table__date">
                    {new Date(event.startdate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </td>
                  <td className="viewing-organiser-events-table__date">
                    {new Date(event.enddate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </td>
                  <td>
                    <span className={getStatusClass(event.status)}>{event.status}</span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="viewing-organiser-no-events">
                  No events found for this organizer
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EventsHostedCard;
